<template>
	<div class="information-container">
		<!-- Divider -->
		<divider-generic :applyBorder="false" :dividerSize="'medium'" :icon="'person'" :title="t('userArea.profile.personalInfoTitle')"/>
		<!-- *********************************************
		*                  Image Uploader                *
		********************************************** -->
		<!-- Web -->
		<profile-image-selector v-if="!getMobileAppState" class="info-block"/>
		<!-- Mobile -->
        <mobile-profile-image-uploader v-else class="info-block"/>
		<!-- *********************************************
		*                     User Info                  *
		********************************************** -->
		<text-blocks-generic class="info-block" :params="nameParams"/>
		<text-blocks-generic class="info-block" :params="emailParams"/>
		<text-blocks-generic class="info-block" :params="phoneNumberParams"/>
		<text-blocks-generic class="info-block" :params="addressParams"/>
		<text-blocks-generic class="info-block" :params="postalCodeParams"/>
		<text-blocks-generic class="info-block" :params="birthDateParams"/>
		<text-blocks-generic class="info-block" :params="nationalityParams"/>
		<text-blocks-generic class="info-block" :params="maritalStatusParams"/>
	</div>
</template>

<script setup>
import TextBlocksGeneric from '@/components/generic/textBlocks/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'
import ProfileImageSelector from '@/components/generic/uploader/WebImageUploader'
import MobileProfileImageUploader from '@/components/generic/uploader/profileImageUploader/MobileImageUploader'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* Assets & Helpers */
import { computed } from 'vue'
import { getDate } from '@/assets/scripts/dateBuilders'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getMobileAppState } = mapGetters()
const { getCustomerContactsInfo } = mapGetters(moduleMapper.USER_AREA_PROFILE)

console.log('here')

/* Props received:
@personalData { Object }
*/
const props = defineProps({
    personalData: Object
})

const nameParams = computed(() => {
	return {
		label: t('userArea.profile.name'),
		content: props.personalData.name ? props.personalData.name : t('emptyFieldState')
	}
})

const emailParams = computed(() => {
	return {
		label: t('userArea.profile.email'),
		content: props.personalData.email ? props.personalData.email : t('emptyFieldState')
	}
})

const phoneNumberParams = computed(() => {
    let defaultContact = '-'

    if (getCustomerContactsInfo.value && getCustomerContactsInfo.value.length) {
        if (getCustomerContactsInfo.value.find((element) => { return element.default })) {
            defaultContact = getCustomerContactsInfo.value.find((element) => { return element.default }).contact
        } else defaultContact = getCustomerContactsInfo.value[0].contact
    }

	return {
		label: t('userArea.profile.phoneAssociated'),
		content: defaultContact
	}
})
const addressParams = computed(() => {
	return {
		label: t('userArea.profile.address'),
		content: props.personalData.address ? props.personalData.address : t('emptyFieldState')
	}
})

const postalCodeParams = computed(() => {
	return {
		label: t('userArea.profile.postalCode'),
		content: props.personalData.postalCode ? props.personalData.postalCode : t('emptyFieldState')
	}
})

const birthDateParams = computed(() => {
	return {
		label: t('userArea.profile.birthDate'),
		content: props.personalData.birthday ? getDate(props.personalData.birthday) : t('emptyFieldState'),
		classes: 'capitalize'
	}
})

const nationalityParams = computed(() => {
	return {
		label: t('userArea.profile.nationality'),
		content: props.personalData.nationality ? props.personalData.nationality : t('emptyFieldState')
	}
})

const maritalStatusParams = computed(() => {
	return {
		label: t('userArea.profile.maritalStatus'),
		content: props.personalData.maritalStatus ? props.personalData.maritalStatus : t('emptyFieldState')
	}
})

</script>

<style lang="scss" scoped>
.information-container {
	width: 100%;
    max-width: 508px;
    margin-bottom: 24px;

	:deep(.divider-generic-wrapper) {
		margin-bottom: 24px;
	}

	.info-block {
		margin-bottom: 16px;

		&:last-of-type {
			margin-bottom: 0;
		}
	}

	:deep(.phone-number-selector-wrapper) {
		max-width: 320px;
	}
}
</style>
